import { Theme, css } from '@emotion/react';

export const menuStickyContainerStyles = ({ colors, spacing, breakpoints }: Theme) => css`
  background-color: ${colors.bgDefault};
  top: 0;
  padding: 0 ${spacing(2.5)}px;
  position: sticky;
  z-index: theme.zIndex.speedDial;
  ${breakpoints.up('sm')} {
    padding: 0 ${spacing(3.5)}px;
  }
`;

export const menuGroupContainerStyles = ({ colors, spacing, breakpoints }: Theme) => css`
  background-color: ${colors.bgDefault};
  padding: ${spacing(2.5)}px;
  &:last-child {
    border-bottom: none;
  }
  ${breakpoints.up('sm')} {
    padding: ${spacing(3.5)}px;
  }
`;
